import React, { useEffect, useState } from 'react';
import { Row, Modal, ModalBody } from 'reactstrap';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

var unique = require('array-unique');
export default function PrequalTvChannelsPopUp(props) {
    const [displayModel, setdisplayModel] = useState(true);
    const [eirTvLogo, setEirTvLogo] = useState(
        '/.galleries/customise-page/eir-tv-logo-blackfont.png'
    );
    const [eirTvExtraLogo, setEirTvExtraLogo] = useState(
        '/.galleries/customise-page/eir-tv-extra-logo-whitefont.png'
    );
    const toggleModel = () => {
        setdisplayModel(false);
        props.handleClose(false);
    };
    const viewChannels = () => {
        setdisplayModel(true);
    };
    const handleTabSelect = key => {
        if (key == 'eir TV') {
            setEirTvLogo('/.galleries/customise-page/eir-tv-logo-blackfont.png');
            setEirTvExtraLogo('/.galleries/customise-page/eir-tv-extra-logo-whitefont.png');
        } else {
            setEirTvLogo('/.galleries/customise-page/eir-tv-logo-whitefont.png');
            setEirTvExtraLogo('/.galleries/customise-page/eir-tv-extra-logo-blackfont.png');
        }
    };

    let eirTvChannels = [];
    let eirTvExtraChannels = [];
    /* ************************ TV Channels popup - start ************************ */
    let getTvChannels;
    //get the list of channels from the opencms component
    for (let i = 0; i < window.components.length; i++) {
        if (window.components[i].type == 'eir-customise-tv-channels') {
            getTvChannels = window.components[i].cmsContent.tvlogos;
        }
    }
    //sort the channels based on the eirtv, eirtv extra and push them to respective arrays
    for (var i in getTvChannels) {
        if (getTvChannels[i].image.indexOf('/eirtvplus') > 0) {
            eirTvChannels.push(getTvChannels[i]);
        } else if (getTvChannels[i].image.indexOf('/eirtvextra') > 0) {
            eirTvExtraChannels.push(getTvChannels[i]);
        }
    }

    let getUniqueGenreEirTv = [];
    let getUniqueGenreEirExtraTv = [];
    for (let i = 0; i < eirTvChannels.length; i++) {
        getUniqueGenreEirTv.push(eirTvChannels[i].category);
    }
    for (let i = 0; i < eirTvExtraChannels.length; i++) {
        getUniqueGenreEirExtraTv.push(eirTvExtraChannels[i].category);
    }
    var printEirTvChannels = '';
    var printEirTvExtraChannels = '';
    // add html elements to render the channels based on the selected tab in the overlay
    setTimeout(() => {
        for (var i = 0; i < unique(getUniqueGenreEirTv).length; i++) {
            printEirTvChannels +=
                '<div><div class=" mb-2 col-12"><h4>' +
                getUniqueGenreEirTv[i] +
                '</h4><div class="aaa">';
            for (var j = 0; j < eirTvChannels.length; j++) {
                if (getUniqueGenreEirTv[i] === eirTvChannels[j].category) {
                    printEirTvChannels +=
                        "<img class='channel-img' alt='" +
                        eirTvChannels[j].alt +
                        "' src='" +
                        eirTvChannels[j].image +
                        "' />";
                }
            }
            printEirTvChannels += '</div></div>';
        }
        $('#eirTvChannels-ctr').html(printEirTvChannels);

        for (let i = 0; i < unique(getUniqueGenreEirExtraTv).length; i++) {
            printEirTvExtraChannels +=
                '<div><div class=" mb-2"><h4>' + getUniqueGenreEirExtraTv[i] + '</h4>';
            for (let j = 0; j < eirTvExtraChannels.length; j++) {
                if (getUniqueGenreEirExtraTv[i] === eirTvExtraChannels[j].category) {
                    printEirTvExtraChannels +=
                        "<img class='channel-img' alt='" +
                        eirTvExtraChannels[j].alt +
                        "' src='" +
                        eirTvExtraChannels[j].image +
                        "' />";
                }
            }
            printEirTvExtraChannels += '</div>';
        }
        $('#eirTvExtraChannels-ctr').html(printEirTvExtraChannels);
    }, 200);

    return (
        <div>
            <Modal
                className='modalDialog tv-channels-popup'
                centered={true}
                isOpen={displayModel}
                toggle={toggleModel}>
                <ModalBody className={'modalContent '}>
                    <img
                        onClick={toggleModel}
                        src={'/.galleries/eir/icons/plus-circle-hover.png'}
                        alt='Close'
                        className='phonedetails-close-icon'
                    />
                    <Tabs
                        defaultActiveKey='eir TV'
                        id='noanim-tab-example'
                        onSelect={handleTabSelect}>
                        <Tab
                            eventKey='eir TV'
                            title={
                                <img
                                    src={eirTvLogo}
                                    id='eirTvTab'
                                    alt='eir TV'
                                    className='tv-channel-popup-nav-logo'
                                />
                            }>
                            <Row
                                id='eirTvChannels-ctr'
                                className='customise-page-channels-ctr'></Row>
                        </Tab>
                        <Tab
                            eventKey='eir TV Extra'
                            title={
                                <img
                                    src={eirTvExtraLogo}
                                    id='eirTvExtraTab'
                                    alt='eir TV Extra'
                                    className='tv-channel-popup-navitem-logo'
                                />
                            }>
                            <Row
                                id='eirTvExtraChannels-ctr'
                                className='customise-page-channels-ctr'></Row>
                        </Tab>
                    </Tabs>
                </ModalBody>
            </Modal>
        </div>
    );
}
